module.exports = __webpack_public_path__ + "img/pause.a3831225.svg";